export default __webpack_public_path__ + "static/media/DCC-Logo.de8aa1c4.png";